import { AXIOS_DELETE, AXIOS_GET, AXIOS_POST } from "../../server/api/crud";
import { BASE_URL_API } from "../../constants/constants";
import { getAccesToken } from "../../Localstorage/localstorage";

export async function fetchAdminMailboxMessages({ folder = "INBOX", limit = 50 } = {}) {
  const safeFolder = encodeURIComponent(folder || "INBOX");
  const response = await AXIOS_GET(`adminmailbox/messages?folder=${safeFolder}&limit=${limit}`);
  return response.data;
}

export async function fetchAdminMailboxFolders() {
  const response = await AXIOS_GET("adminmailbox/folders");
  return response.data;
}

export async function fetchAdminMailboxMessage(id, { folder = "INBOX" } = {}) {
  const safeFolder = encodeURIComponent(folder || "INBOX");
  const response = await AXIOS_GET(`adminmailbox/messages/${id}?folder=${safeFolder}`);
  return response.data;
}

export async function sendAdminMailboxMessage(payload) {
  const response = await AXIOS_POST("adminmailbox/send", payload);
  return response.data;
}

export async function moveAdminMailboxMessage(id, payload) {
  const response = await AXIOS_POST(`adminmailbox/messages/${id}/move`, payload);
  return response.data;
}

export async function deleteAdminMailboxMessage(id, { folder = "INBOX" } = {}) {
  const response = await AXIOS_DELETE("adminmailbox/messages", id, { folder });
  return response.data;
}

export async function toggleAdminMailboxMessageFlag(id, payload) {
  const response = await AXIOS_POST(`adminmailbox/messages/${id}/flag`, payload);
  return response.data;
}

export async function markAdminMailboxMessageSeen(id, payload) {
  const response = await AXIOS_POST(`adminmailbox/messages/${id}/seen`, payload);
  return response.data;
}

export async function saveAdminMailboxDraft(payload) {
  const response = await AXIOS_POST("adminmailbox/drafts", payload);
  return response.data;
}

export async function downloadAdminMailboxAttachment(id, attachmentId, { folder = "INBOX", filename = "bijlage" } = {}) {
  const safeFolder = encodeURIComponent(folder || "INBOX");
  const response = await fetch(
    `${BASE_URL_API}/adminmailbox/messages/${id}/attachments/${attachmentId}/download?folder=${safeFolder}`,
    {
      headers: {
        Authorization: `Bearer ${getAccesToken() || ""}`,
      },
    }
  );
  if (!response.ok) return false;

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename || "bijlage";
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
  return true;
}
